import { useMutation } from '@apollo/client';

import { UpdateBedroomInput } from '../../apollo/__generated__/graphql';
import { UPDATE_BEDROOM } from '../graphql/mutation/updateBedroomMutation.graphql';
import { BEDROOMS } from '../graphql/query/bedroomsQuery.graphql';
import { EVENT_BEDROOMS } from '../graphql/query/eventBedroomsQuery.graphql';
import { PLACES } from '../graphql/query/placesQuery.graphql';

export const useUpdateBedroomMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(UPDATE_BEDROOM, { onCompleted });

  const updateBedroom = (updateBedroomInput: UpdateBedroomInput) => {
    mutate({
      variables: {
        updateBedroomInput,
      },
      refetchQueries: [BEDROOMS, PLACES, EVENT_BEDROOMS],
    });
  };

  return { updateBedroom };
};
